import * as React from "react"
import type { SVGProps } from "react"

export const BookmarkMinusFilledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M15.75 7a.73.73 0 0 1-.534-.216A.73.73 0 0 1 15 6.25q0-.32.216-.535a.73.73 0 0 1 .534-.215h4q.318 0 .534.216a.73.73 0 0 1 .216.534q0 .32-.216.535A.73.73 0 0 1 19.75 7zM12 17.462l-3.97 1.703q-.903.387-1.716-.145-.814-.532-.814-1.506V5.308q0-.746.531-1.277A1.74 1.74 0 0 1 7.308 3.5h5.346a.66.66 0 0 1 .61.357.78.78 0 0 1 .032.743 4 4 0 0 0-.228.79Q13 5.786 13 6.25q0 1.77 1.147 3.093T17 10.93q.184.03.33.038t.285.008a.93.93 0 0 1 .626.248.77.77 0 0 1 .259.59v5.7q0 .975-.814 1.506-.813.533-1.717.146z"
    ></path>
  </svg>
)
